import React from 'react';
import style from './headerbuttonmvp.module.scss';

const HeaderButtonMVP = ({ children, headButtVisibol, classname = style.headerButton }) => (
  <div className={`${style.headerButton} ${classname}`} style={headButtVisibol}>
    {children}
  </div>
);

export default HeaderButtonMVP;
